var exports = {
  "H": "xdde3148b--5c18ec--action-buttons",
};

module.exports = exports;
